<script setup>
import { useNavigation } from "@/app/composables/useNavigation";
import {
  PRACTICE_NAME,
  CONTACT_INFO,
  SITE_LABELS,
  THERAPIST_NAME,
} from "@/content/site";
import ContentCard from "@/app/components/common/ContentCard.vue";

const { navigateToMore } = useNavigation();
</script>

<template>
  <div class="centering-flex-container fill-height">
    <!-- Back button -->
    <div class="back-button-container">
      <button class="back-btn" @click="navigateToMore">
        {{ SITE_LABELS.backButtonToMoreInfoLabel }}
      </button>
    </div>
    <header class="header-section">
      <h1>Datenschutzerklärung</h1>
    </header>

    <ContentCard class="intro-card" noBox
      ><h2>1. Datenschutz im Überblick</h2>
      <p>
        Diese Website erfasst bewusst so wenig personenbezogene Daten wie
        möglich. Es erfolgt kein Tracking, keine Cookies und keine Analyse Ihres
        Nutzerverhaltens. Personenbezogene Daten werden nur dann verarbeitet,
        wenn Sie aktiv mit uns Kontakt aufnehmen.
      </p>

      <h2>2. Verantwortliche Stelle</h2>
      <p>Verantwortlich für die Datenverarbeitung auf dieser Website:</p>
      <p>
        {{ PRACTICE_NAME }}<br />
        {{ THERAPIST_NAME }}<br />
        {{ CONTACT_INFO.address.street }}<br />
        {{ CONTACT_INFO.address.zipCity }}
      </p>
      <p>
        Telefon: {{ CONTACT_INFO.phone }}<br />
        E-Mail: {{ CONTACT_INFO.email }}
      </p>
      <p>
        Ein Datenschutzbeauftragter ist aufgrund der Art und des Umfangs der
        Datenverarbeitung nicht bestellt und gesetzlich nicht erforderlich.
      </p>

      <h2>3. Welche Daten werden verarbeitet?</h2>

      <h3>Website-Bereitstellung (Hosting)</h3>
      <p>
        Diese Website wird bei der Hetzner Online GmbH (Industriestr. 25, 91710
        Gunzenhausen) gehostet, einem deutschen Anbieter mit Serverstandorten in
        Deutschland. Die Verarbeitung erfolgt im Rahmen einer
        Auftragsverarbeitung gemäß Art. 28 DSGVO.
      </p>
      <p>
        <strong>Verarbeitete Daten:</strong> Diese Website erfasst
        <strong>keine regulären Access-Logs</strong>. Bei normalen
        Website-Besuchen werden keine IP-Adressen gespeichert.
      </p>
      <p>
        Nur bei <strong>kritischen Server-Fehlern</strong> (schwerwiegende
        technische Störungen, keine normalen 404-Fehler) werden IP-Adressen
        temporär in Error-Logs gespeichert. Dies erfolgt ausschließlich zur
        Behebung technischer Probleme und zur Gewährleistung der Sicherheit der
        Website.
      </p>
      <p>
        Bei solchen kritischen Fehlern können folgende Daten verarbeitet werden:
        IP-Adresse, Zeitpunkt des Fehlers, Browsertyp, aufgerufene URL.
      </p>
      <p>
        <strong>Zweck:</strong> Technische Bereitstellung, Stabilität und
        Sicherheit der Website<br />
        <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO
        (berechtigtes Interesse an einer stabilen und sicheren Website)<br />
        <strong>Speicherdauer:</strong> Error-Logs werden automatisch nach
        spätestens 7 Tagen gelöscht. Logs, die zur Behebung einer konkreten
        Störung benötigt werden, werden nach Abschluss der Fehlerbehebung
        unverzüglich gelöscht.
      </p>
      <p>
        Eine Übermittlung personenbezogener Daten in Drittländer findet nicht
        statt.
      </p>

      <h3>Kontakt per E-Mail oder Telefon</h3>
      <p>
        Wenn Sie uns per E-Mail oder Telefon kontaktieren, werden Ihre
        Kontaktdaten (E-Mail-Adresse, ggf. Name und Telefonnummer) sowie Ihr
        Anliegen verarbeitet. Die Angabe dieser Daten erfolgt freiwillig. Ohne
        diese Angaben kann Ihre Anfrage jedoch nicht bearbeitet werden.
      </p>
      <p>
        <strong>Zweck:</strong> Bearbeitung Ihrer Anfrage, Terminvereinbarung<br />
        <strong>Rechtsgrundlage:</strong>
        Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung im Rahmen einer
        therapeutischen Anfrage) oder Art. 6 Abs. 1 lit. f DSGVO (berechtigtes
        Interesse an der Beantwortung sonstiger Anfragen)<br />
        <strong>Speicherdauer:</strong> Bis zur abschließenden Bearbeitung Ihrer
        Anfrage oder auf Ihren Wunsch zur Löschung, sofern keine gesetzlichen
        Aufbewahrungspflichten bestehen
      </p>

      <h3>Patientendokumentation</h3>
      <p>
        Unabhängig von der Nutzung dieser Website wird im Rahmen einer
        therapeutischen Behandlung eine Patientendokumentation geführt. Diese
        umfasst Stammdaten, Anamnese, Diagnosen, Behandlungsverlauf und ggf.
        Abrechnungsdaten.
      </p>
      <p>
        <strong>Zweck:</strong> Durchführung der psychotherapeutischen
        Behandlung<br />
        <strong>Rechtsgrundlage:</strong>
        Art. 9 Abs. 2 lit. h DSGVO i.V.m. § 22 BDSG (Gesundheitsversorgung)
        sowie Art. 9 Abs. 2 lit. a DSGVO (Einwilligung)<br />
        <strong>Speicherdauer:</strong> Mindestens 10 Jahre nach Behandlungsende
        entsprechend berufsrechtlicher und gesetzlicher Vorgaben
      </p>

      <h2>4. Weitergabe von Daten</h2>
      <p>
        Ihre personenbezogenen Daten werden grundsätzlich nicht an Dritte
        weitergegeben, außer:
      </p>
      <ul>
        <li>Sie haben ausdrücklich eingewilligt</li>
        <li>Es besteht eine gesetzliche Verpflichtung</li>
        <li>
          Die Weitergabe ist für die therapeutische Behandlung erforderlich
          (z.B. Überweisung an einen Facharzt mit Ihrer ausdrücklichen
          Einwilligung)
        </li>
      </ul>

      <h2>5. Ihre Rechte</h2>
      <p>
        Sie haben jederzeit die Kontrolle darüber, welche personenbezogenen
        Daten wir über Sie speichern und wie diese verarbeitet werden. Ihnen
        stehen insbesondere folgende Rechte zu:
      </p>

      <ul class="rights-list">
        <li>
          <span class="right-title">Auskunft</span>
          <span class="right-text"
            >Sie können erfahren, welche personenbezogenen Daten über Sie
            gespeichert sind.</span
          >
        </li>
        <li>
          <span class="right-title">Berichtigung</span>
          <span class="right-text"
            >Sie können die Korrektur unrichtiger oder unvollständiger Daten
            verlangen.</span
          >
        </li>
        <li>
          <span class="right-title">Löschung</span>
          <span class="right-text"
            >Sie können die Löschung Ihrer Daten verlangen, soweit keine
            Aufbewahrungspflichten bestehen.</span
          >
        </li>
        <li>
          <span class="right-title">Einschränkung der Verarbeitung</span>
          <span class="right-text"
            >Sie können verlangen, dass Ihre Daten nur noch eingeschränkt
            verarbeitet werden.</span
          >
        </li>
        <li>
          <span class="right-title">Datenübertragbarkeit</span>
          <span class="right-text"
            >Sie können Ihre Daten in einem strukturierten, gängigen Format
            erhalten.</span
          >
        </li>
        <li>
          <span class="right-title">Widerspruch</span>
          <span class="right-text"
            >Sie können der Verarbeitung widersprechen, sofern diese auf
            berechtigten Interessen beruht.</span
          >
        </li>
        <li>
          <span class="right-title">Widerruf von Einwilligungen</span>
          <span class="right-text"
            >Sie können eine erteilte Einwilligung jederzeit mit Wirkung für die
            Zukunft widerrufen.</span
          >
        </li>
      </ul>

      <p>
        Zur Ausübung Ihrer Rechte wenden Sie sich bitte an die oben genannten
        Kontaktdaten.
      </p>

      <h2>6. Besondere Vertraulichkeit (Heilberuf)</h2>
      <p>
        Als Heilpraktikerin für Psychotherapie unterliege ich der gesetzlichen
        Schweigepflicht nach § 203 StGB. Alle Informationen aus der
        therapeutischen Behandlung werden streng vertraulich behandelt.
      </p>
      <p>
        Gesundheitsdaten zählen zu den besonders schützenswerten
        personenbezogenen Daten gemäß Art. 9 DSGVO und werden mit erhöhten
        technischen und organisatorischen Sicherheitsmaßnahmen verarbeitet.
      </p>

      <h2>7. Technische Sicherheit</h2>
      <p>
        Diese Website nutzt eine SSL/TLS-Verschlüsselung (erkennbar an
        „https://“ und dem Schloss-Symbol im Browser). Dadurch werden
        übertragene Daten vor dem Zugriff unbefugter Dritter geschützt.
      </p>
      <p>
        Weitere Maßnahmen: Keine externen Tracking-Dienste, keine Cookies,
        ausschließlich selbst gehostete Schriftarten und Ressourcen.
      </p>

      <h2>8. Hinweis zur Datenübertragung im Internet</h2>
      <p>
        Die Datenübertragung im Internet (z.B. per E-Mail) kann
        Sicherheitslücken aufweisen. Ein vollständiger Schutz vor dem Zugriff
        durch Dritte ist nicht möglich. Bitte übermitteln Sie sensible
        Gesundheitsinformationen nicht unverschlüsselt per E-Mail. Alternativ
        empfehlen wir den telefonischen Kontakt.
      </p>

      <p style="margin-top: 2rem; font-size: 0.9em; opacity: 0.8">
        Stand: Februar 2026
      </p>
    </ContentCard>
  </div>
</template>

<style scoped>
.centering-flex-container.fill-height {
  padding: 0 var(--spacing-md);
}

header {
  text-align: center;
  margin-bottom: var(--spacing-sm);
  flex-shrink: 0;
}

header h1 {
  font-family: var(--font-heading), serif;
  font-size: var(--font-size-xxxl);
  font-weight: var(--font-weight-light);
  color: var(--color-cream);
  margin-bottom: var(--spacing-xs);
  letter-spacing: var(--letter-spacing-tight);
  line-height: var(--line-height-tight);
  margin-left: var(--letter-spacing-widest);
}

.intro-card {
  flex: 0 1 auto;
  overflow-y: auto;
  min-height: 0;
}

.intro-card :deep(a) {
  color: var(--color-cream);
  text-decoration: underline;
  transition: opacity var(--transition-normal);
}

.intro-card :deep(a:hover) {
  opacity: 0.8;
}

.intro-card :deep(ul) {
  margin: var(--spacing-sm) 0;
  padding-left: var(--spacing-md);
}

.intro-card :deep(ul li) {
  margin-bottom: var(--spacing-xs);
}

.rights-list > li {
  display: flex; /* bleibt Flex, wie dein Setup */
  flex-direction: column; /* Titel + Text untereinander */
  align-items: flex-start;
  margin-bottom: var(--spacing-sm);
}

.right-title {
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-compact);
}

.right-text {
  margin-top: 0.15em; /* kleine Lücke zwischen Titel und Text */
  font-weight: var(--font-weight-light);
  line-height: var(--line-height-body);
}

@media (max-width: 480px) {
  .centering-flex-container.fill-height {
    justify-content: space-between;
    padding: 0 var(--spacing-sm);
    gap: var(--spacing-sm);
  }

  .header-section {
    margin-top: 4rem;
    margin-bottom: 0;
    flex-shrink: 0;
  }

  header h1 {
    letter-spacing: var(--letter-spacing-wider);
    font-size: var(--font-size-xxl);
    margin-bottom: var(--spacing-xxs);
  }

  .intro-card h2 {
    letter-spacing: var(--letter-spacing-tight);
    font-size: var(--font-size-xl);
    margin-bottom: var(--spacing-xxs);
    text-wrap: wrap;
  }

  .intro-card a {
    word-break: break-all;
  }
}
</style>
